<template>
  <!-- 抱怨单 -->
  <h-list-page class="sqmComplaintList">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area :all-span="5">
        <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
          <h-select v-model="searchData.happenSybId" clearable filterable @change="changeNull(searchData.happenSybId, 'happenSybId')">
            <h-option
              v-for="item in data.sybAllList"
              :key="item.departmentId"
              :label="item.departmentName"
              :value="item.departmentId"
            ></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
          <h-select
            clearable
            v-model="searchData.complainStatus"
            :placeholder="h_i18n('cb08af880c276d42e7773bcd88331d25')"
            filterable
            @change="changeNull(searchData.complainStatus, 'complainStatus')"
          >
            <h-option v-for="(item, index) in data.pubList.complainStatuses" :key="index" :value="item.valueId" :label="item.valueName"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('b060eca2b49819ee8ccebe9df36f3a2c')">
          <h-select
            clearable
            v-model="searchData.complainProperty"
            :placeholder="h_i18n('cb08af880c276d42e7773bcd88331d25')"
            filterable
            @change="changeNull(searchData.complainProperty, 'complainProperty')"
          >
            <h-option v-for="(item, index) in data.pubList.complainProperties" :key="index" :value="item.valueId" :label="item.valueName"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('a0ecbfa1e4cdb310961027f6ab4083dd')">
          <h-select
            clearable
            v-model="searchData.complainType"
            :placeholder="h_i18n('dda7a81e664a14ec816355d82c0f5a57')"
            filterable
            @change="changeNull(searchData.complainType, 'complainType')"
          >
            <h-option v-for="item in data.complainTypeList" :key="item.valueId" :label="item.valueName" :value="item.valueId"></h-option>
          </h-select>
        </h-search>
        <h-search :title="h_i18n('0039880117c13787732d259f5bc9f7f5')">
          <h-date-picker
            @change="TimeChange(searchData.inputDate, { start: 'isrtBeginDate', end: 'isrtEndDate' })"
            v-model="searchData.inputDate"
            type="daterange"
            :start-placeholder="h_i18n('b44c0f337d2ffc27a09ff792a489b1e0')"
            :end-placeholder="h_i18n('1d468be946f7be1133b3e2c682eee8c6')"
            :clearable="clearAble"
          />
        </h-search>
        <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>
      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('b1b3a37705497b49f330710167e01724')" :h-data="data.dataOfTable" :is-left="1" style="margin-top: 12px">
      <template #buttonGroup>
        <template v-for="item in data.buttonList">
          <h-button type="primary" @click="EXport" :key="item.code" v-if="item.code == 'mkhl_oldbyd_new_export'" style="margin-right: 12px;">
            <template #icon>
              <i class="iconfont icon-daochu"></i>
            </template>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
        </template>
        <div
          style="display: flex; align-items: center; background: #fff7e8; border: 1px solid #ffe4ba; border-radius: 6px; padding: 0px 16px; font-size: 14px; height: 28px;"
        >
          <img style="width: 14px;height: 14px;margin-right: 4px;" src="@/assets/svg/h-warning.svg" alt="" />{{ h_i18n('29defff86bab9b0c1537e411f39e6e84') }}</div>
      </template>

      <el-table
        :empty-text="h_i18n('21efd88b67a39834582ad99aabb9dc60')"
        v-loading="data.tableLoading"
        border
        :data="data.dataOfTable"
        size="small"
        height="540"
        style="width: 100%; min-height: 540px"
      >
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column :label="h_i18n('0e0ab4ecf3679493d91ca2c5e67057b7')" width="180">
          <template #default="{ row }">
            <span style="color: #0000ff; cursor: pointer" @click="handleClickCode(row)">{{ row.complainCode }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="140">
          <template #default="{ row }">
            <span>{{ getValueName(data.pubList.complainStatuses, row.complainStatus) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130"></el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200"></el-table-column>
        <el-table-column :label="h_i18n('b060eca2b49819ee8ccebe9df36f3a2c')" width="130">
          <template #default="{ row }">
            <span>{{ getValueName(data.pubList.complainProperties, row.complainProperty) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('a0ecbfa1e4cdb310961027f6ab4083dd')" width="170">
          <template #default="{ row }">
            <span v-if="row.complainProperty == '1318'">{{ getValueName(data.pubList.complainTypeImps, row.complainType) }}</span>
            <span v-else-if="row.complainProperty == '1319'">{{ getValueName(data.pubList.complainTypeUnImps, row.complainType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="happenSybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" width="110"></el-table-column>
        <el-table-column :label="h_i18n('a8e450d03efd4f33232169538abcec3e')" width="110">
          <template #default="{ row }">
            <span v-if="row.happenNode == 1335">{{ h_i18n('5be77cbffda8cb572d17e7cccfde5dd4') }}</span>
            <span v-else-if="row.happenNode == 1336">{{ h_i18n('0653329dcfb42539677f84b3bd94b826') }}</span>
            <span v-else-if="row.happenNode == 1337">{{ h_i18n('a3c853b28fc22514a82e9b97550a5bb8') }}</span>
            <span v-else-if="row.happenNode == 1338">{{ h_i18n('3b9d92eca3709a56edfed5be784406cb') }}</span>
            <span v-else-if="row.happenNode == 1339">{{ h_i18n('eb7b9e9f7281fe68d0dc4c631a522eca') }}</span>
            <span v-else-if="row.happenNode == 2999">{{ h_i18n('f5a6a3a1e5bcddf045542b92ff04a564') }}</span>
            <span v-else>{{ row.happenNode }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('1bbe6ebe11a361d576f88cda2d2e32b8')" width="110">
          <template #default="{ row }">
            <span>{{ time(row.happenDate) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rectificationTime" :label="h_i18n('c852df6b19811c526adf5bd774b2d0df')" min-width="120">
          <template #default="{ row }">
            <span>{{ time(row.rectificationTime, 3) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('0039880117c13787732d259f5bc9f7f5')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.isrtDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="analyzeConclusion" :label="h_i18n('37c356f85613c01a79bbe51ede1b892b')" width="130"></el-table-column>
        <el-table-column :label="h_i18n('0780b822291d73c370688ea1cda76b16')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.analyzeDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="confirmConclusion" :label="h_i18n('91822d2fcc8dbddc3f2337f092d09af7')" width="200"></el-table-column>
        <el-table-column :label="h_i18n('df713dfbe610b926ac70234219f1230b')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.confirmDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sqeConclusion" :label="h_i18n('4945e9d7e48ef34ee612bf930966c6f3')" width="130"></el-table-column>
        <el-table-column :label="h_i18n('be6970e437146dcd1831c82b37fdc46f')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.sqeDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('ecbd3df43afb03834741469f71ea5d02')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.rectificationDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="closedConclusion" :label="h_i18n('3cdea1bb0f30aa0ca0eb9d07118b76ef')" width="200"></el-table-column>
        <el-table-column :label="h_i18n('b6307063367a403379617c8f6ad43a3b')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.closedDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('010e174d02a4a28f6f0eb2df0cab1fec')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.isrtDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="h_i18n('80d0e2aaf0c6883e2a6e6078619385b1')" width="180">
          <template #default="{ row }">
            <span>{{ time(row.closedDate, 6) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="claimMoney" :label="h_i18n('fc889bb1c8d1c8190d64beb59341820b')" width="130"></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getInfo"
        v-model:currentPage="searchData.pageNo"
        :page-size="10"
        layout="total, prev, pager, next,jumper"
        :total="data.total"
      >
      </el-pagination>
    </h-table-card>
  </h-list-page>
</template>

<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';

const { proxy, ctx } = getCurrentInstance();
const route = useRoute();

const searchData = reactive({
  sybId: '',
  complainStatus: '',
  complainProperty: '',
  complainType: '',
  beginDateOne: '',
  endDateOne: ''
});
const data = reactive({
  sybAllList: [],
  productLinesList: [],
  complainTypeList: [],
  mtlNoList: [],
  mtlLoading: false,
  supplyLoading: false,
  tableLoading: false,
  exportLoading: false,
  supplyCodeList: [],
  rowListOfCheck: [],
  dataOfTable: [],
  buttonList: [],
  pubList: [],
  roleCode: '',
  total: 0
});
onMounted(() => {
  if (!route.query.name) {
    proxy.info({
      title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
      message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: action => {
        proxy.$router.back();
      }
    });
    return;
  }
  if (route.query) {
    searchData.complainStatus = route.query.complainStatus;
    searchData.supplyCode = route.query.supplyCode;
    searchData.supplyName = route.query.supplyName;
    searchData.name = route.query.name;
    searchData.nickName = route.query.nickName;
    data.roleCode = 'S006';
    data.name = route.query.name;
    data.nickName = route.query.nickName;
    window.getItemName = route.query.name;
    window.getItemNickName = route.query.nickName;
  }
  if (route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != '') {
    let p = proxy.getButtonFromSqm(route.query.parentId, route.query.roleCode);
    p.then(res => {
      if (res.length > 0) {
        data.buttonList = res;
      }
      console.log(data.buttonList);
    });
  }
  getInitComplainOld();
  getSybList();
  productLines();
});

onActivated(() => {
  getInfo(true);
});

// 抱怨单号
const handleClickCode = row => {
  proxy.$router.push({
    name: 'OldSqmComplaintDetails',
    query: {
      complainId: row.complainId,
      supplyCode: route.query.supplyCode,
      name: data.name,
      nickName: data.nickName
    }
  });
};

// 获取抱怨单状态等list
const getInitComplainOld = () => {
  proxy
    .$http({
      method: 'get',
      url: '/base/complainOld/initComplainOld',
      dataType: 'application/json',
      params: { name: data.name }
    })
    .then(res => {
      console.log('initComplainOld', res);
      if (res.status === 200) {
        data.pubList = res.data.data;
      }
    })
    .catch(err => proxy.error(h_i18n('1c42e6cbb34709fc90974a6ec1a3497e') + proxy.errorDispose(err.response.data || err.response || err)));
};

const getValueName = (list, id) => {
  let name = '';
  list.forEach(item => {
    if (item.valueId === id) {
      name = item.valueName;
    }
  });
  return name;
};

/**
 * 传高度
 */
const changeMethod = () => {
  proxy.postThisPageHeight();
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === '') {
    searchData[key] = undefined;
  }
  if (key === 'complainProperty') {
    if (!value) {
      searchData.complainType = '';
      data.complainTypeList = [];
      return;
    }
    if (value == 1318) {
      data.complainTypeList = data.pubList.complainTypeImps;
    }
    if (value == 1319) {
      data.complainTypeList = data.pubList.complainTypeUnImps;
    }
  }
};
// 导出 emr/export
const EXport = () => {
  if (data.total > 200000) {
    proxy.warning({
      message: h_i18n('c54045d692bedb6365e073ce45b4e57e'),
      title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: action => {}
    });
    return;
  }
  if (data.total < 1) {
    proxy.warning({
      message: h_i18n('f59ec2b6c282f2c37663f524c2a318c3'),
      title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: action => {}
    });
    return;
  }
  data.exportLoading = true;
  proxy.startLoading(h_i18n('7c4b0bddeadbb3ca7adaa3f5ed1d7333'));
  proxy
    .httpFile(
      {
        method: 'post',
        url: '/base/complainOld/export',
        data: {
          ...searchData,
          flag: 'sqm'
        }
      },
      h_i18n('017ade634e8dc53cb5f828254de984a4')
    )
    .then(res => {
      data.exportLoading = false;
    })
    .catch(err => {
      data.exportLoading = false;
      proxy.closeLoading();
    });
  data.exportLoading = false;
};
// 产业线查询
const productLines = () => {
  return proxy
    .$http({
      method: 'get',
      url: `/base/colorBoardManagementPlatform/selectPLInfoListForSQM`,
      dataType: 'application/json',
      params: {
        name: route.query.supplyCode,
        nickName: route.query.supplyName
      }
    })
    .then(res => {
      console.log(res);
      if (res.status === 200) {
        data.productLinesList = res.data.data;
      }
    })
    .catch(err => proxy.error(h_i18n('52dc3a1c87479531fb9e09d933025f34') + this.errorDispose(err.response.data || err.response || err)));
};
// 查询
const getInfo = flag => {
  if (true == flag) {
    searchData.pageNo = 1;
  }
  data.tableLoading = true;
  proxy
    .$http({
      url: '/base/complainOld/listPage',
      method: 'post',
      data: {
        ...searchData,
        flag: 'sqm',
        queryFlag: 'sqm',
        supplyName: undefined,
      }
    })
    .then(res => {
      if (res.data.code === '200') {
        data.dataOfTable = res.data.data.records;
        data.total = res.data.data.total;
        data.tableLoading = false;
      } else {
        data.dataOfTable = [];
        data.tableLoading = false;
        proxy.warning({
          message: res.data.msg ? res.data.msg : h_i18n('21efd88b67a39834582ad99aabb9dc60'),
          title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770')
        });
      }
    })
    .catch(err => {
      data.dataOfTable = [];
      data.tableLoading = false;
      proxy.warning({ message: err ? err : h_i18n('0d66ed02d74d0bd89431d6d59533ffb3'), title: h_i18n('acd5cb847a4aff235c9a01ddeb6f9770') });
    });
};

// 两个模糊查询相关
const http = reactive({
  mtlSearchHttp: false,
  supplySearchHttp: false
});

// 时间范围选择
const TimeChange = (date, { start, end }) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
};

// 获取工厂小微
const getSybList = () => {
  proxy
    .$http({
      method: 'get',
      url: '/base/OqcA/listSyb',
      headers: { 'content-type': 'application/json' },
      params: {
        userName: data.name,
        name: data.name,
        nickName: data.nickName
      }
    })
    .then(res => {
      data.sybAllList = res.data;
    });
};
</script>

<style lang="scss">
.sqmComplaintList {
  .haier-card .haier-card--body .el-table tr td {
    padding: 11.1px 0;
  }

  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }

  tr:nth-child(1) {
    th:nth-child(1) {
      border-left: 0 solid #e5e6eb !important;
    }
  }

  tr:last-child {
    th {
      border-bottom: 0 solid #e5e6eb !important;
    }
  }

  tr {
    th {
      border-left: 1px solid #e5e6eb !important;
    }
  }
}

.dialog_style .haier-dialog {
  top: 1%;
}

.planHidden {
  display: none;
}

.a_tr_style {
  margin: 10px;
  margin-top: -10px;
  border: 1px solid #ccc;
  border-top: 0px;
  padding: 10px;
  display: flex;

  .insert_content_style {
    display: flex;
    width: 100%;

    div {
      line-height: 50px;
    }
  }

  .left_style {
    width: 66.66%;
  }

  .right_style {
    width: 33.33%;
    height: 100%;
    border: 1px solid #ccc;
    min-height: 350px;
  }

  .last_style {
    position: relative;
    right: -50%;
  }
}

.td-tableOfClass {
  padding: 0px !important;

  .cell {
    padding: 0px !important;
  }
}

.tableOfClass {
  width: 100%;
  border-right: 1px solid rgb(236, 236, 236);
  border-left: 1px solid rgb(236, 236, 236);

  .el-table__header-wrapper {
    table {
      thead {
        tr {
          th {
            font-size: 12px !important;
            font-weight: 500 !important;
            height: 28px !important;
            padding: 0px !important;
            background-color: #e8f3ff;
            border-right: 0px !important;
          }
        }
      }
    }
  }

  .el-table__body-wrapper {
    .el-table__empty-block {
      min-height: 28px !important;

      .el-table__empty-text {
        line-height: 28px;
        font-size: 12px;
      }
    }

    .el-table__body {
      .el-table__row {
        td {
          font-size: 12px;
          line-height: 28px;
          padding: 0px !important;
          height: 28px;
          border-right: 0px !important;
        }
      }
    }
  }
}

.wrapDiv {
  .el-pagination {
    height: 24px;

    span {
      font-size: 12px;
    }

    button {
      background: transparent !important;
    }

    ul {
      background: transparent !important;

      li {
        background: transparent !important;
      }
    }
  }
}

.table_button_style {
  padding: 7px 0 !important;
}
</style>